/* Dynamic Plot code copyright 2017 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 * Numerical Decimal places selection component, allow user to override
 * decimal places for the current attribute.
 */

import React from "react";
import { decimalPoints } from "../../../utils/constants";
import IncrDecrInput from "../../common/IncrDecrInput.jsx";
import ToolTip from "../../common/ToolTip.js";

class NumericDecimalsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // value: this.props.attributeObj.stats.isNumeric() ? "numerical" : "categorical"
            // To support the subtype along with datatype of the attribute
            value: this.props.attributeObj.getNumericDecimals()
        };
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc(str);
    };

    render = () => {
        return (
            <div className="tde-numeric-component tde-p-0 tde-divider-bottom tde-pb-4 tde-pt-4 tde-mt-4 tde-divider-top">
                <div
                    className={
                        "tde-row tde-mb-3" +
                        (this.props.reduceCaseCardWidth
                            ? " tde-px-2"
                            : " tde-px-3")
                    }
                >
                    <div className="tde-label tde-mb-2 tde-font-weight-bold">
                        {this.getLoc("Decimals")}
                        <ToolTip
                            tip={this.getLoc(
                                "Increase or decrease decimal places"
                            )}
                            Dyn={this.props.Dyn}
                            dir="r"
                        >
                            <i className="tde-i tde-i-help tde-ml-1"></i>
                        </ToolTip>
                    </div>
                    <IncrDecrInput
                        label={"Decimals"}
                        getLoc={this.getLoc}
                        value={this.state.value}
                        onChange={(value) =>
                            this.setState(
                                {
                                    value,
                                },
                                this.props.handleChange({
                                    filterChanged: true,
                                    dataType: "numerical",
                                    component: "numeric-decimals",
                                    numericDecimals: Number(value),
                                })
                            )
                        }
                        options={decimalPoints}
                    />
                </div>
            </div>
        );
    };
}

export default NumericDecimalsComponent;
